// @flow

import * as React from 'react'
import { connect, type Connector } from 'react-redux'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import { Button } from 'semantic-ui-react'
import ChartFilterToolbar from './chart-filter-toolbar'
import FileDownloaderButton from '../systemwide/file-downloader-button'
import { addErrorNotification } from '../store/notification-manager'
import { setStartDate, setEndDate, getSummaryData, toggleFilter } from '../store/reports'

import moment from 'moment'
import type { ReduxState, Dispatch } from '../store'

type OwnProps = {||}

type MappedProps = {|
  currentCampaign: string,
  showWeb: boolean,
  showPhone: boolean,
  showF2F: boolean,
  startDate: moment$Moment,
  endDate: moment$Moment,
  filter: string,
  sortKey: string,
  sortDir: string,
  totRecords: number,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  return {
    currentCampaign: state.allowedCampaigns.currentCampaign,
    showWeb: state.reports.ui.showWeb,
    showPhone: state.reports.ui.showPhone,
    showF2F: state.reports.ui.showF2F,
    startDate: state.reports.ui.startDate,
    endDate: state.reports.ui.endDate,
    filter: state.reports.grid.filterTerms,
    sortKey: state.reports.grid.sortKey,
    sortDir: state.reports.grid.sortDir,
    totRecords: state.reports.grid.totRecords,
  }
}

type Props = { dispatch: Dispatch } & OwnProps & MappedProps

type DatePickerProps = {|
  text: string,
  onClick: Function,
  date: moment$Moment,
|}

class CustomDatePicker extends React.Component<DatePickerProps> {
  static defaultProps = {
    onClick: () => {},
  }

  render() {
    return (
      <Button.Group size="small">
        <Button primary content={this.props.text} />
        <Button
          onClick={this.props.onClick}
          content={this.props.date.format('DD-MM-YYYY')}
          style={{ color: 'black', minWidth: '12ex' }}
        />
      </Button.Group>
    )
  }
}

class VisitsReportToolbar extends React.Component<Props> {
  static defaultProps = {}

  onToggleFilter = (value: 'web' | 'phone' | 'f2f') => {
    this.props.dispatch(toggleFilter(value))
  }

  onDownloadError = () => {
    this.props.dispatch(addErrorNotification('Errore di download'))
  }

  handleChangeStart = (date: moment$Moment) => {
    let startDate = date.isAfter(this.props.endDate) ? this.props.endDate : date
    this.props.dispatch(setStartDate(startDate))
    this.props.dispatch(
      getSummaryData(
        this.props.currentCampaign,
        startDate.format('YYYYMMDD'),
        this.props.endDate.format('YYYYMMDD'),
        this.props.showWeb.toString(),
        this.props.showF2F.toString(),
        this.props.showPhone.toString()
      )
    )
  }

  handleChangeEnd = (date: moment$Moment) => {
    let endDate = date.isBefore(this.props.startDate) ? this.props.startDate : date
    this.props.dispatch(setEndDate(endDate))
    this.props.dispatch(
      getSummaryData(
        this.props.currentCampaign,
        this.props.startDate.format('YYYYMMDD'),
        endDate.format('YYYYMMDD'),
        this.props.showWeb.toString(),
        this.props.showF2F.toString(),
        this.props.showPhone.toString()
      )
    )
  }

  render() {
    return (
      <span>
        <div style={{ float: 'left' }}>
          <DatePicker
            customInput={<CustomDatePicker date={this.props.startDate} text="Da:" />}
            dateFormat="DD/MM/YYYY"
            locale="it"
            selected={this.props.startDate}
            maxDate={moment()}
            selectsStart
            disabledKeyboardNavigation
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            onChange={this.handleChangeStart}
          />
        </div>

        <div style={{ float: 'left', marginLeft: '1ex' }}>
          <DatePicker
            customInput={<CustomDatePicker date={this.props.endDate} text="A:" />}
            dateFormat="DD/MM/YYYY"
            locale="it"
            selected={this.props.endDate}
            maxDate={moment()}
            selectsEnd
            disabledKeyboardNavigation
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            onChange={this.handleChangeEnd}
          />
        </div>

        <div style={{ float: 'left', marginLeft: '2ex' }}>
          <ChartFilterToolbar
            showWeb={this.props.showWeb}
            showPhone={this.props.showPhone}
            showF2F={this.props.showF2F}
            onToggleFilter={this.onToggleFilter}
          />
        </div>
        <div style={{ float: 'left', marginLeft: '2ex' }}>
          <FileDownloaderButton
            downloadUrl={
              '/api/reports/' +
              this.props.currentCampaign +
              '/doctor_list/export/' +
              this.props.startDate.format('YYYYMMDD') +
              '/' +
              this.props.endDate.format('YYYYMMDD') +
              '/' +
              this.props.showWeb.toString() +
              '/' +
              this.props.showF2F.toString() +
              '/' +
              this.props.showPhone.toString()
            }
            downloadParams={{
              filter: this.props.filter,
              sortKey: this.props.sortKey,
              sortDir: this.props.sortDir,
            }}
            label="Esporta"
            disabled={this.props.totRecords === 0}
            onError={this.onDownloadError}
          />
        </div>
      </span>
    )
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(VisitsReportToolbar)



// WEBPACK FOOTER //
// ./src/reports/visits-details-report-toolbar.js